(function(){
    'use strict';
    angular.module('app').controller('AddNewSurchargeModalController', AddNewSurchargeModalController);
    AddNewSurchargeModalController.$inject = [
        '$uibModalInstance',
        '$q',
        'AccountingService',
        'toastr'
    ];

    function AddNewSurchargeModalController(
        $uibModalInstance,
        $q,
        AccountingService,
        toastr
    ) {
        const vm = this;
        vm.onCancelButtonClicked = onCancelButtonClicked;
        vm.onAddButtonClicked = onAddButtonClicked;
        vm.onSearchSurcharges = onSearchSurcharges;

        init();
        function init() {
        }

        function onSearchSurcharges(search) {
            getSurchargesData(search).then(data => {
               vm.surchargesData = data;
            });
        }

        function getSurchargesData(filters) {
            const defer = $q.defer();
            AccountingService.Surcharges.getAll(data => {
                defer.resolve(data.content);
            }, error => {
                toastr.error('Unable to fetch surcharges data', error.message);
                defer.reject(error);
            });
            return defer.promise;
        }

        function onCancelButtonClicked() {
            $uibModalInstance.dismiss();
        }

        function onAddButtonClicked(form) {
            $uibModalInstance.close(vm.surcharge);
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/AddNewSurchargeModalController.js